import ViewComponent from './view';
import ImageComponent from './image';


export const View = ViewComponent;
export const Image = ImageComponent;



// WEBPACK FOOTER //
// ./src/ui/index.js